import { useCallback } from 'react';
import classnames from 'classnames/bind';
import { ToolbarToggle } from 'components';
import { LOGICAL_OPERATOR } from 'modules/push-api/utils/subscriptionConsts';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import styles from './andOrToggle.module.scss';

const classNameBuilder = classnames.bind(styles);

export const AndOrToggle = () => {
    const { value: logicalOperatorFormValue, onChange: setLogicalOperatorFormValue } = useFormFieldValue({
        field: 'logicalOperator',
    });

    const handleToggle = useCallback(
        value => {
            setLogicalOperatorFormValue(value);
        },
        [setLogicalOperatorFormValue]
    );

    return (
        <ToolbarToggle
            leftChild="AND"
            rightChild="OR"
            isLeftToggleSelected={logicalOperatorFormValue === LOGICAL_OPERATOR.AND}
            onLeftChildClick={() => handleToggle(LOGICAL_OPERATOR.AND)}
            onRightChildClick={() => handleToggle(LOGICAL_OPERATOR.OR)}
            containerClassName={styles['toggleContainer']}
            leftToggleOverride={classNameBuilder(
                styles['toggleButton'],
                logicalOperatorFormValue === LOGICAL_OPERATOR.AND && styles['active']
            )}
            rightToggleOverride={classNameBuilder(
                styles['toggleButton'],
                logicalOperatorFormValue === LOGICAL_OPERATOR.OR && styles['active']
            )}
        />
    );
};
